const math =`# Math (using KaTeX)

$\\sqrt{3x-1}+(1+x)^2$

#### For more information, please see:

[https://github.com/waylonflinn/markdown-it-katex](https://github.com/waylonflinn/markdown-it-katex)

#### Demo:

[http://waylonflinn.github.io/markdown-it-katex/](http://waylonflinn.github.io/markdown-it-katex/)

`
export {math}



// WEBPACK FOOTER //
// ./src/boilerplates/math.js